import {
  SELLERBALANCEFORM_ENTER_RESET,
  SELLERBALANCEFORM_EDITFORM_CHANGE,
  SELLERBALANCEFORM_ADDITEM_LOAD,
  SELLERBALANCEFORM_ADDITEM_SUCCEED,
  SELLERBALANCEFORM_ADDITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case SELLERBALANCEFORM_ENTER_RESET:
      return {}
    case SELLERBALANCEFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case SELLERBALANCEFORM_ADDITEM_LOAD:
      return {
        ...state,
        isAddItemLoading: true,
        isAddItemSuccess: false,
        addItemError: null,
      }
    case SELLERBALANCEFORM_ADDITEM_SUCCEED:
      return { ...state, isAddItemLoading: false, isAddItemSuccess: true }
    case SELLERBALANCEFORM_ADDITEM_FAIL:
      return { ...state, isAddItemLoading: false, addItemError: action.addItemError }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/sellerBalanceForm.js